import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import moment from 'moment';
import HomeData from "./homedata";
import { encryptString, decryptCipher } from "@/utilities/CommonUtilities";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        homeData: HomeData
    },
    plugins: [
        createPersistedState({
           storage: localStorage,
        }),
      ],
    state: {
        token: null,
        userInfo: null,
        listUser: null,
        timeSavedListUser: null,
        listReason: null,
    },
    getters: {
        isSignedIn(state) {
            return state.token != null;
        },
        credentialInfo(state){
            return {
                userName: localStorage.isWillSaveCredential ? localStorage.userName : null,
                password: localStorage.isWillSaveCredential ? decryptCipher(localStorage.password) : null,
                token: state.token,
                isWillSaveCredential: (localStorage.isWillSaveCredential || false)
            };
        },
        getUserByID(state) {
            return function(userID) {
                if(state.listUser != null && state.listUser.length > 0) {
                    let index = state.listUser.findIndex(u => u.userID == userID);
                    if(index != -1) {
                        let thisUser = {};
                        Object.assign(thisUser, state.listUser[index]);
                        return thisUser;
                    }
                }
                return null;
            };
        },
        getTypeAndReasonByReasonID(state) {
            return function(reasonID) {
                if(state.listReason != null && state.listReason.length > 0) {
                    for(let i = 0; i < state.listReason.length; i++) {
                        let type = state.listReason[i];
                        for(let j = 0; j < type.reasons.length; j++) {
                            let reason = type.reasons[j];
                            if(reason.id == reasonID) {
                                return {
                                    type:{name_en: type.name_en, name_jp: type.name_jp, name_vi: type.name_vi},
                                    reason: reason
                                }
                            }
                        }
                    }
                }
                return null;
            };
        },
        getListType(state) {
            if(state.listReason != null && state.listReason.length > 0) {
                return state.listReason.map(t => { 
                    return {
                        duration: t.duration,
                        id: t.id, 
                        name_en: t.name_en, 
                        name_jp: t.name_jp, 
                        name_vi: t.name_vi
                    }
                });
            }
            return [];
        },
        getListReasonByTypeID(state) {
            return function(typeID) { 
                if(state.listReason != null && state.listReason.length > 0) {
                    for(let i = 0; i < state.listReason.length; i++) {
                        let type = state.listReason[i];
                        if(type.id == typeID) {
                            return type.reasons;
                        }
                    }
                }
                return [];
            }
        },
        getDurationByTypeID(state) {
            return function(typeID) { 
                if(state.listReason != null && state.listReason.length > 0) {
                    for(let i = 0; i < state.listReason.length; i++) {
                        let type = state.listReason[i];
                        if(type.id == typeID) {
                            return type.duration;
                        }
                    }
                }
                return null;
            }
        }
    },
    mutations: {
        loadCachedInfo(currentState) {
            currentState.token = localStorage.token;
        },
        saveCredentialInfo(currentState, credentialInfo) {
            currentState.token = credentialInfo.token;
            currentState.userInfo = credentialInfo.userInfo;

            //save data for refresh page
            localStorage.clear();
            localStorage.userName = credentialInfo.userName;
            localStorage.password = encryptString(credentialInfo.password);
            localStorage.token = credentialInfo.token;

            if(credentialInfo.isWillSaveCredential) {
                localStorage.isWillSaveCredential = credentialInfo.isWillSaveCredential;
            } else {
                localStorage.isWillSaveCredential = '';
            }
        },
        signOut(currentState) {
            currentState.token = null;
            currentState.userInfo = null;
            currentState.listUser = null;
            currentState.listReason = null;

            if(!localStorage.isWillSaveCredential) {
                localStorage.clear();
            } else {
                localStorage.token = null;
            }
        },
        saveListUser(currentState, listUser) {
            currentState.listUser = listUser;
            currentState.timeSavedListUser = moment().format('YYYY/MM/DD HH:mm:ssZ');
        },
        saveListReason(currentState, listReason) {
            currentState.listReason = listReason;
        },
        updateUserInfo(currentState, newUserInfo) {
            if(newUserInfo.userID == currentState.userInfo.userID) {
                currentState.userInfo = newUserInfo;
            }
            
            let index = currentState.listUser.findIndex(user => user.userID == newUserInfo.userID);
            if(index > -1) {
                currentState.listUser[index] = newUserInfo;
            }
        }
    },
    actions: {
        signOut(context) {
            context.commit('signOut');
            context.commit('homeData/signOut');
            context.dispatch('homeData/resetAllTabInfo');
        }
    }
})